/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Preprocessing_LabelInputs */



/**
* | output |
* | --- |
* | "Enhance image for OCR" |
*
* @param {Ocr_Preprocessing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_preprocessing_label = /** @type {((inputs?: Ocr_Preprocessing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Preprocessing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Améliorer l'image pour la reconnaissance optique de caractères (OCR)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bild für OCR optimieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Migliora l'immagine per l'OCR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Улучшение изображения для распознавания текста.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mejorar la imagen para OCR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("增强图像以利于OCR识别")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCR用に画像を補正する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("OCR के लिए छवि को बेहतर बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprimorar imagem para OCR")
	return /** @type {LocalizedString} */ ("Enhance image for OCR")
});